<template>
  <!-- Poll -->
  <div class="pollDiv" @click="noticeEvent('showNotice')">
    <block-title @noticeEvent="noticeEvent" :message="message" />
    <div class="categoryDiv">
      <img class="categoryIcon" src="@/assets/poll_sml.png" />
      Poll
      <span class="yearBlock pull-right" v-if="message.years">
        Years:
        <b>{{ message.years }}</b>
      </span>
      <span
        class="yearBlock pull-right"
        v-if="!message.years && !message.class_label"
      >
        Years:
        <b>All</b>
      </span>
      <span class="yearBlock pull-right" v-if="message.class_label">
        <b>{{ message.class_label }}</b>
      </span>
    </div>
    <!-- <div class='leftBlock'> -->
    <div v-if="message.message.length > 5">
      <p class="blockText noticeText polltext" v-html="message.message"></p>
    </div>
    <div
      class="text-bold marginLeft40 positionRelative"
      style="padding-top: 14px"
    >
      <strong class="questionLabel">Q: {{ message.title }}</strong>
    </div>
    <div v-if="message.extras.answers" class="positionRelative">
      <p class="marginLeft40" style="font-size: 10px">
        (All responses are anonymous)
      </p>
      <ul class="pollChoices">
        <li :key="$index" v-for="(answer, $index) in message.extras.answers">
          <!-- <button
            v-if="!message.viewed_status && message.user_id != user_id"
            class="btn btn-default rounded25"
            @click="pollAnswer($index)"
            :class="{ active: answerIndex == $index ? true : false }"
          >
            <strong style="color: black">
              <i class="far fa-comment"></i>
            </strong>
            {{ answer.answer }}
          </button> -->
          <span class="answerIcon">
            <strong>
              <i class="fas fa-check-circle"></i>
            </strong>
            {{ answer.answer }}
          </span>
          <div
            class="pollResultLine"
            v-if="answer.value"
            :style="{
              width: (answer.value * 100) / message.extras.total_votes + '%',
            }"
          >
            <span>
              {{
                parseInt(
                  (answer.value * 100) / parseInt(message.extras.total_votes)
                )
              }}%
            </span>
          </div>
          <div v-if="!answer.value && message.extras.total_votes === 0">
            <span>0%</span>
          </div>
          <div
            class="pollResultLine"
            v-if="!answer.value"
            :style="{ width: '40px' }"
          >
            <span>0%</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div v-if='message.extras.poll_type.type != "fixed" && message.extras.poll_type != "" ' style='margin-top: 15px;'>
    <p style="font-size: 10px;">(All responses are anonymous)</p>
    <textarea class='form-control' ng-maxlength="180" ng-trim='true' maxlength='180' placeholder="Respond here (180 character limit)" style='margin-bottom:10px' ng-model='pollAnswerText' ng-change='pollIdSelected = message.extras.poll_id'></textarea>
    </div>-->
    <!-- <div
      class="marginLeft40 positionRelative"
      v-if="!message.viewed_status && message.user_id != user_id"
    >
      <el-button
        class="pollButton round25"
        size="small"
        :disabled="answerIndex > -1 ? false : true"
        title="Please select an answer to submit"
        @click="pollSubmit()"
      >
        Submit
      </el-button>
    </div> -->
    <span class="seeMoreLabel nomargin" v-if="message.user_id == user_id">
      Total votes:
      <span>{{ message.extras.total_votes || 0 }}</span>
    </span>
    <div class="pollPaddingFix"></div>
    <div
      class="institution"
      v-if="
        message.user_type != 3 &&
        message.user_type != 5 &&
        message.user_type != 1
      "
    >
      <img src="@/assets/triangle.png" class alt />
      <div class="logo">
        <img
          v-if="message.school_logo"
          :src="
            message.bucket_url +
            '/council/schools/photo/100/' +
            message.school_logo
          "
          alt
        />
      </div>
    </div>
    <NoticeFooter @noticeEvent="noticeEvent" :message="message" />
    <div style="clear: both"></div>
  </div>
  <!-- End Poll -->
</template>
<style scoped></style>
<script>
import BlockTitle from "@/components/noticeTypes/other/BlockTitle";
import NoticeFooter from "@/components/noticeTypes/other/NoticeFooter";
import ApiService from "@/services/ApiService";

export default {
  name: "poll",
  components: {
    BlockTitle,
    NoticeFooter,
  },
  data() {
    return {
      answerIndex: -1,
      pollAnswerText: "",
    };
  },
  props: {
    message: Object,
    pollIdSelected: Number,
    user_id: Number,
    // title: String,
    // icon: String
  },
  methods: {
    noticeEvent(type) {
      this.$emit("noticeEvent", {
        action: type,
        id: this.message.notice_user_id,
        user_id: this.message.user_id,
      });
    },
    pollAnswer(index) {
      this.answerIndex = index;
    },
    pollSubmit() {
      const textAnswer = this.pollAnswerText != "" ? this.pollAnswerText : null;

      ApiService.generalApi
        .pollAnswer(
          this.message.extras.poll_id,
          this.answerIndex,
          this.message.id,
          textAnswer
        )
        .then((response) => {
          this.message.is_read = 1;
          this.message.viewed_status = 1;
          this.message.extras = JSON.parse(response.data.poll_data);
        });
    },
  },
};
</script>
